export const NonClikkleItems = [
    {
        type: 'folder',
        name: 'Research Papers',
        location: '/research',
        owner: 'Me',  // Updated owner
        size: '1GB',
        reason: 'Contains academic research papers',
        clikkle: false,
        date: '10/20/2024'
    },
    {
        type: 'folder',
        name: 'Client Presentations',
        location: '/clients/presentations',
        owner: 'Me',  // Updated owner
        size: '800MB',
        reason: 'Presentation slides for client meetings',
        clikkle: false,
        date: '09/12/2024'
    },
    {
        type: 'file',
        name: 'Budget Report',
        location: '/finance/budget',
        owner: 'Me',  // Updated owner
        size: '450KB',
        reason: 'Detailed budget allocation report',
        clikkle: false,
        date: '08/15/2024'
    },
    {
        type: 'folder',
        name: 'Product Launch Plans',
        location: '/projects/launch',
        owner: 'Me',  // Updated owner
        size: '2GB',
        reason: 'Documents related to the upcoming launch',
        clikkle: false,
        date: '07/30/2024'
    },
    {
        type: 'folder',
        name: 'Legal Documents',
        location: '/legal',
        owner: 'Me',  // Updated owner
        size: '750MB',
        reason: 'Legal agreements and contracts',
        clikkle: false,
        date: '06/25/2024'
    },
    {
        type: 'file',
        name: 'Annual Report 2023',
        location: '/corporate/reports',
        owner: 'Me',  // Updated owner
        size: '2.5MB',
        reason: 'Company annual report for 2023',
        clikkle: false,
        date: '05/18/2024'
    },
    {
        type: 'folder',
        name: 'Marketing Strategy 2024',
        location: '/marketing/strategy',
        owner: 'Me',  // Updated owner
        size: '1.2GB',
        reason: 'Strategic plan for marketing in 2024',
        clikkle: false,
        date: '04/10/2024'
    },
    {
        type: 'folder',
        name: 'HR Policies',
        location: '/hr/policies',
        owner: 'Me',  // Updated owner
        size: '300MB',
        reason: 'Human resources policies and guidelines',
        clikkle: false,
        date: '03/25/2024'
    },
    {
        type: 'file',
        name: 'Employee Benefits',
        location: '/hr/benefits',
        owner: 'Me',  // Updated owner
        size: '450KB',
        reason: 'List of employee benefits and perks',
        clikkle: false,
        date: '02/18/2024'
    },
    {
        type: 'folder',
        name: 'Customer Feedback',
        location: '/customers/feedback',
        owner: 'Me',  // Updated owner
        size: '1GB',
        reason: 'Compilation of customer feedback surveys',
        clikkle: false,
        date: '01/30/2024'
    }
];

export const RandomClikkleItems = [
    {
        type: "file",
        name: "Employee Handbook",
        location: "/hr/handbook",
        owner: "Me",  // Updated owner
        size: "300KB",
        reason: "Guide for employee policies",
        clikkle: false,
        date: '05/10/2024'
    },
    {
        type: "file",
        name: "Quarterly Review",
        location: "/reviews/q2",
        owner: "Me",  // Updated owner
        size: "550KB",
        reason: "Review of Q2 performance",
        clikkle: false,
        date: '04/15/2024'
    },
    {
        type: "file",
        name: "System Architecture",
        location: "/tech/architecture",
        owner: "Me",  // Updated owner
        size: "1.2MB",
        reason: "Blueprint of system architecture",
        clikkle: false,
        date: '03/20/2024'
    },
    {
        type: "file",
        name: "User Feedback",
        location: "/feedback/users",
        owner: "Me",  // Updated owner
        size: "600KB",
        reason: "Compiled user feedback data",
        clikkle: false,
        date: '02/18/2024'
    },
    {
        type: "file",
        name: "Employee Payroll",
        location: "/hr/payroll",
        owner: "Me",  // Updated owner
        size: "500KB",
        reason: "Monthly payroll data",
        clikkle: false,
        date: '01/25/2024'
    },
    {
        type: "file",
        name: "Marketing Proposal",
        location: "/marketing/proposal",
        owner: "Me",  // Updated owner
        size: "1MB",
        reason: "Proposal for next marketing campaign",
        clikkle: false,
        date: '12/15/2023'
    },
    {
        type: "folder",
        name: "IT Infrastructure Docs",
        location: "/it/infrastructure",
        owner: "Me",  // Updated owner
        size: "2GB",
        reason: "Documentation for IT infrastructure",
        clikkle: false,
        date: '11/05/2023'
    },
    {
        type: "folder",
        name: "Database Optimization Guides",
        location: "/it/database",
        owner: "Me",
        size: "1.5GB",
        reason: "Guides on optimizing database performance",
        clikkle: false,
        date: '10/12/2023'
    },
    {
        type: "folder",
        name: "Cloud Migration Plan",
        location: "/it/cloud",
        owner: "Me",
        size: "3GB",
        reason: "Detailed plan for migrating to the cloud",
        clikkle: false,
        date: '09/20/2023'
    },
    
    {
        type: "file",
        name: "Employee Training Materials",
        location: "/training/materials",
        owner: "Me",  // Updated owner
        size: "1.5MB",
        reason: "Training material for employees",
        clikkle: false,
        date: '10/28/2023'
    },
    {
        type: "folder",
        name: "Project Roadmaps",
        location: "/projects/roadmaps",
        owner: "Me",  // Updated owner
        size: "3GB",
        reason: "Roadmaps for ongoing projects",
        clikkle: false,
        date: '09/14/2023'
    },
    
    {
        type: "file",
        name: "Employee Satisfaction",
        location: "/hr/satisfaction",
        owner: "Me",  // Updated owner
        size: "800KB",
        reason: "Survey to gauge employee satisfaction",
        clikkle: false,
        date: '08/10/2023'
    },
    
    
    
];

export const ClikkleItems = [
    {
        type: 'folder',
        name: 'Clikkle DevOps',
        location: '/clikkle/devops',
        owner: 'Me',  // Updated owner
        size: '150MB',
        reason: 'Scripts and tools for CI/CD pipelines',
        clikkle: true,
        date: '01/10/2024'
    },
    {
        type: 'folder',
        name: 'Clikkle UI Designs',
        location: '/clikkle/ui/designs',
        owner: 'Me',  // Updated owner
        size: '300MB',
        reason: 'Clikkle interface design assets',
        clikkle: true,
        date: '12/05/2023'
    },
    {
        type: 'folder',
        name: 'Clikkle Content Strategy',
        location: '/clikkle/content',
        owner: 'Me',  // Updated owner
        size: '200MB',
        reason: 'Content plans and drafts for campaigns',
        clikkle: true,
        date: '11/15/2023'
    },
    {
        type: 'folder',
        name: 'Clikkle Server Configurations',
        location: '/clikkle/servers',
        owner: 'Me',  // Updated owner
        size: '100MB',
        reason: 'Configuration files for servers',
        clikkle: true,
        date: '10/01/2023'
    },
    {
        type: 'file',
        name: 'Clikkle Vision Document',
        location: '/clikkle/vision',
        owner: 'Me',  // Updated owner
        size: '1MB',
        reason: 'Future roadmap and vision for Clikkle',
        clikkle: true,
        date: '09/10/2023'
    },
    {
        type: 'folder',
        name: 'Clikkle Marketing Campaigns',
        location: '/clikkle/marketing/campaigns',
        owner: 'Me',  // Updated owner
        size: '500MB',
        reason: 'Marketing materials and campaigns assets',
        clikkle: true,
        date: '08/22/2023'
    },
    {
        type: 'folder',
        name: 'Clikkle Customer Support',
        location: '/clikkle/support',
        owner: 'Me',  // Updated owner
        size: '350MB',
        reason: 'Support documentation and guides',
        clikkle: true,
        date: '07/18/2023'
    },
    {
        type: 'file',
        name: 'Clikkle Launch Presentation',
        location: '/clikkle/presentation/launch',
        owner: 'Me',  // Updated owner
        size: '2.5MB',
        reason: 'Presentation for Clikkle launch event',
        clikkle: true,
        date: '06/12/2023'
    },
    {
        type: 'file',
        name: 'Clikkle Quarterly Review',
        location: '/clikkle/review/q1',
        owner: 'Me',  // Updated owner
        size: '1.8MB',
        reason: 'Quarterly review document for Q1 2023',
        clikkle: true,
        date: '05/25/2023'
    },
    {
        type: 'folder',
        name: 'Clikkle Product Specifications',
        location: '/clikkle/product/specifications',
        owner: 'Me',  // Updated owner
        size: '900MB',
        reason: 'Product specifications for upcoming release',
        clikkle: true,
        date: '04/30/2023'
    }
];
